import React from 'react';
export const DrawerContext = React.createContext({
    drawerRef: { current: null },
    overlayRef: { current: null },
    onPress: () => { },
    onRelease: () => { },
    onDrag: () => { },
    onNestedDrag: () => { },
    onNestedOpenChange: () => { },
    onNestedRelease: () => { },
    openProp: undefined,
    dismissible: false,
    isOpen: false,
    isDragging: false,
    keyboardIsOpen: { current: false },
    snapPointsOffset: null,
    snapPoints: null,
    handleOnly: false,
    modal: false,
    shouldFade: false,
    activeSnapPoint: null,
    onOpenChange: () => { },
    setActiveSnapPoint: () => { },
    closeDrawer: () => { },
    direction: 'bottom',
    shouldAnimate: { current: true },
    shouldScaleBackground: false,
    setBackgroundColorOnScale: true,
    noBodyStyles: false,
    container: null,
    autoFocus: false,
});
export const useDrawerContext = () => {
    const context = React.useContext(DrawerContext);
    if (!context) {
        throw new Error('useDrawerContext must be used within a Drawer.Root');
    }
    return context;
};
